/*
Author       : Dreamguys
Template Name: Pathivu - Bootstrap Template
Version      : 1.0
*/

(function ($) {
    "use strict";

    // Stick Sidebar

    if ($(window).width() > 767) {
        if ($('.theiaStickySidebar').length > 0) {
            $('.theiaStickySidebar').theiaStickySidebar({
                // Settings
                additionalMarginTop: 30
            });
        }
    }

    // Sidebar

    if ($(window).width() <= 991) {
        var Sidemenu = function () {
            this.$menuItem = $('.main-nav a');
        };

        function init() {
            var $this = Sidemenu;
            $('.main-nav a').on('click', function (e) {
                if ($(this).parent().hasClass('has-submenu')) {
                    e.preventDefault();
                }
                if (!$(this).hasClass('submenu')) {
                    $('ul', $(this).parents('ul:first')).slideUp(350);
                    $('a', $(this).parents('ul:first')).removeClass('submenu');
                    $(this).next('ul').slideDown(350);
                    $(this).addClass('submenu');
                } else if ($(this).hasClass('submenu')) {
                    $(this).removeClass('submenu');
                    $(this).next('ul').slideUp(350);
                }
            });
        }

        // Sidebar Initiate
        init();
    }

    $(function () {
        // Textarea Text Count
        var maxLength = 100;
        $('#review_desc').on('keyup change', function () {
            var length = $(this).val().length;
            length = maxLength - length;
            $('#chars').text(length);
        });
    });

    // Mobile menu sidebar overlay

    // Tooltip

    if ($('[data-toggle="tooltip"]').length > 0) {
        $('[data-toggle="tooltip"]').tooltip();
    }

    // Content div min height set

    function resizeInnerDiv() {
        var height = $(window).height();
        var header_height = $(".header").height();
        var footer_height = $(".footer").height();
        var setheight = height - header_height;
        var trueheight = setheight - footer_height;
        $(".content").css("min-height", trueheight);
    }

    if ($('.content').length > 0) {
        resizeInnerDiv();
    }

    $(window).resize(function () {
        if ($('.content').length > 0) {
            resizeInnerDiv();
        }
    });

    // Slick Slider

    if ($('.specialities-slider').length > 0) {
        $('.specialities-slider').slick({
            dots: true,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            prevArrow: false,
            nextArrow: false
        });
    }

    if ($('.doctor-slider').length > 0) {
        $('.doctor-slider').slick({
            dots: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
        });
    }
    if ($('.features-slider').length > 0) {
        $('.features-slider').slick({
            dots: true,
            infinite: true,
            centerMode: true,
            slidesToShow: 3,
            speed: 500,
            variableWidth: true,
            arrows: false,
            autoplay: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }

            }]
        });
    }

    // Date Range Picker
    if ($('.bookingrange').length > 0) {
        var start = moment().subtract(6, 'days');
        var end = moment();

        function booking_range(start, end) {
            $('.bookingrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('.bookingrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, booking_range);

        booking_range(start, end);
    }
    // Chat

    var chatAppTarget = $('.chat-window');
    (function () {
        if ($(window).width() > 991)
            chatAppTarget.removeClass('chat-slide');

        $(document).on("click", ".chat-window .chat-users-list a.media", function () {
            if ($(window).width() <= 991) {
                chatAppTarget.addClass('chat-slide');
            }
            return false;
        });
        $(document).on("click", "#back_user_list", function () {
            if ($(window).width() <= 991) {
                chatAppTarget.removeClass('chat-slide');
            }
            return false;
        });
    })();

    // Preloader

    $(window).on('load', function () {
        if ($('#loader').length > 0) {
            $('#loader').delay(350).fadeOut('slow');
            $('body').delay(350).css({ 'overflow': 'visible' });
        }
    })

    $(document).ready(function () {

        $(".fa-search").click(function () {
            $(".togglesearch").toggle();
            $(".top-search").focus();
        });

    });

    // Testimonial Slider

    if ($('#customers-testimonials').length > 0) {
        // $('#customers-testimonials').owlCarousel({
        //     nav: true,
        //     items: 1,
        //     autoplay: true,
        //     loop: true,
        //     autoplayTimeout: 50000,
        //     navText: ["<i class='fas fa-arrow-left owl-nav-left'></i>", "<i class='fas fa-arrow-right owl-nav-right ml-3'></i>"],
        // });
    }

    //scroll header

    $(document).ready(function () {
        var scroll = $(window).scrollTop();
        if (scroll > 50) {
          $(".header-trans").css("background", "#13563a");
        } else {
          $(".header-trans").css("background", "transparent");
        }
        $(window).scroll(function () {
            scroll = $(window).scrollTop();
            if (scroll > 50) {
                $(".header-trans").css("background", "#13563a");
                $(".header-trans").css("top", "0");
                $(".header-trans").css("position", "fixed");
                $('body').addClass('map-up');
            }

            else {
                $(".header-trans").css("background", "transparent");
                $(".header-trans").css("top", "auto");
                $(".header-trans").css("position", "relative");
                $('body').removeClass('map-up');
            }
        });
    });

})(jQuery);